<ng-template #statusCell let-row="row" let-value="value">
  <span class="status-badge" [class.status-paid]="value === 'Paid'" [class.status-review]="value === 'Review'" [class.status-pending]="value === 'Pending'">
    {{ value }}
  </span>
</ng-template>

<ng-template #customerCell let-row="row">
  <span class="customer-cell">
    <strong>{{ row.customer }}</strong>
    <small>{{ row.region }} · {{ row.channel }}</small>
  </span>
</ng-template>

<ng-template #totalCell let-row="row">
  <span class="money-cell">{{ formatTotal(row) }}</span>
</ng-template>

<example-shell
  exampleId="cell-templates" [title]="title" [summary]="summary" [dataSnippet]="dataSnippet" [events]="events" (clear)="clearEvents()">
  <stackline-data-table
    title="Template cells"
    [columns]="templateColumns"
    [data]="orders"
    [pagination]="true"
    [paginationPerPage]="5"
    [highlightOnHover]="true">
  </stackline-data-table>
</example-shell>
